import React from 'react';
import { View } from 'react-native';
import moment from 'moment';
import { createStyleSheet, useStyleSheet, Text } from '@gopeerproject/ui-kit';
export const Indicators = ({ startHour, endHour }) => {
    var _a, _b, _c, _d, _e;
    const styles = useStyleSheet(getStyles);
    const minutesBetween = ((endHour - startHour) / 4) * 60; // 4 intervals
    const result = [];
    const cur = moment().startOf('day').add(startHour, 'hours');
    const end = moment().startOf('day').add(endHour, 'hours');
    while (cur.isSameOrBefore(end)) {
        result.push(cur.format('h:mm a'));
        cur.add(minutesBetween, 'minutes');
    }
    return (React.createElement(View, { style: styles.container },
        React.createElement(Text, { type: 'body', weight: 'semibold', size: 'sm', style: [styles.indicator, styles.first, { bottom: '100%' }] }, (_a = result[0]) !== null && _a !== void 0 ? _a : '12am'),
        React.createElement(Text, { type: 'body', weight: 'semibold', size: 'sm', style: [styles.indicator, styles.centered, { bottom: '75%' }] }, (_b = result[1]) !== null && _b !== void 0 ? _b : '6am'),
        React.createElement(Text, { type: 'body', weight: 'semibold', size: 'sm', style: [styles.indicator, styles.centered, { bottom: '50%' }] }, (_c = result[2]) !== null && _c !== void 0 ? _c : '12pm'),
        React.createElement(Text, { type: 'body', weight: 'semibold', size: 'sm', style: [styles.indicator, styles.centered, { bottom: '25%' }] }, (_d = result[3]) !== null && _d !== void 0 ? _d : '6pm'),
        React.createElement(Text, { type: 'body', weight: 'semibold', size: 'sm', style: [styles.indicator, { bottom: '0%' }] }, (_e = result[4]) !== null && _e !== void 0 ? _e : '12am')));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        flexDirection: 'column',
        alignSelf: 'flex-end',
        height: '100%',
        width: size.N
    },
    indicator: {
        color: color.invert2.p56,
        position: 'absolute',
        height: size.G,
        textAlign: 'right'
    },
    first: {
        marginBottom: -size.E,
        textAlign: 'left'
    },
    centered: {
        marginBottom: -size.E / 2,
        textAlign: 'center'
    }
}));
//# sourceMappingURL=Indicators.js.map